import React from "react";

import CheckIcon from "@uui/CheckCircle";

import { Stack, Typography, TypographyProps } from "@mui/material";

const FeatureListItem = ({
  children,
  variant = "bodySecondaryReg",
}: {
  children: React.ReactNode;
  variant?: TypographyProps["variant"];
}) => (
  <Stack direction="row" alignItems="center" spacing="12px">
    <CheckIcon sx={{ color: "shades.meadow.500", height: "20px" }} />
    <Typography variant={variant}>{children}</Typography>
  </Stack>
);

export default FeatureListItem;
